export default __webpack_public_path__ + "../staticImages/taste--BARRIQUE_AUSBAU.svg";